import { Box, Button } from '@mui/material';
import { styled } from '@mui/material/styles';

export const PageHeader = styled(Box)(({ theme }) => ({
	display: 'flex',
	justifyContent: 'flex-end',
	alignItems: 'center',
	marginBottom: theme.spacing(3),
}));

export const AddButton = styled(Button)(({ theme }) => ({
	fontWeight: 600,
	textTransform: 'none',
	borderRadius: theme.shape.borderRadius,
	paddingLeft: theme.spacing(2.5),
	paddingRight: theme.spacing(2.5),
	boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
	'&:hover': {
		boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
	},
}));

export const DepartamentosContainer = styled(Box)(({ theme }) => ({
	padding: theme.spacing(4),
	backgroundColor: theme.palette.background.default,
	minHeight: 'calc(100vh - 120px)', // Subtract header height
}));

export const PageNotice = styled(Box)(({ theme }) => ({
	marginBottom: theme.spacing(2),
}));

export const DepartamentosGrid = styled(Box)(({ theme }) => ({
	display: 'grid',
	gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
	gap: theme.spacing(3),
	[theme.breakpoints.up('md')]: {
		gridTemplateColumns: 'repeat(3, 1fr)',
	},
	[theme.breakpoints.down('sm')]: {
		gridTemplateColumns: '1fr',
	},
}));

